<template>
    <transition name="modal">
        <div
            :class="{
                transparent: transparent,
                'is-small': small,
                animate: animate
            }"
            class="modal"
        >
            <div class="backdrop" />

            <div class="modal-body">
                <div
                    v-if="hasCloseButton"
                    class="close-button cursor-pointer"
                    @click="emitCloseEvent"
                >
                    <span class="close-icon">&times;</span>
                </div>

                <div v-if="$slots.icon" class="modal-head-icon">
                    <slot name="icon" />
                </div>

                <div v-if="$slots.title || $slots.subTitle" class="modal-head">
                    <span class="head-title">
                        <slot v-if="$slots.title" name="title" />
                    </span>

                    <span class="head-title sub">
                        <slot v-if="$slots.subTitle" name="subTitle" />
                    </span>
                </div>

                <slot />

                <div v-if="hasActions" class="modal-action-btns">
                    <app-button
                        :disabled="btnDisabled"
                        :loading="btnLoading"
                        @click="btnClick"
                    >
                        {{ btnText }}
                    </app-button>

                    <a @click.prevent="linkClick">
                        {{ linkText }}
                    </a>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
export default {
    name: "app-modal",

    props: {
        small: Boolean,
        transparent: Boolean,
        hasActions: Boolean,
        btnText: {
            type: String,
            default: "המשך"
        },
        btnLoading: Boolean,
        btnDisabled: Boolean,
        linkText: {
            type: String,
            default: "דלג"
        },
        hasCloseButton: Boolean
    },

    data() {
        return {
            animate: false
        };
    },

    created() {
        setTimeout(() => {
            this.animate = true;
        }, 150);
    },

    methods: {
        btnClick() {
            this.$emit("btnClick");
        },
        linkClick() {
            this.$emit("linkClick");
        },
        emitCloseEvent() {
            this.$emit("handle-close");
        }
    }
};
</script>

<style lang="scss" scoped>
.modal {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 100000;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px;
}

.backdrop {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 1;
    background-color: black;
    opacity: 0;
    transition: opacity 0.2s ease-in-out;
}

.modal-body {
    position: fixed;
    top: 0;
    overflow-y: auto;
    z-index: 2;
    width: 100%;
    max-width: 1014px;
    max-height: 100vh;
    opacity: 0;
    transform: translateY(-30%);
    transition: opacity 0.2s ease-in-out, transform 0.4s ease-in-out;
    padding: 50px;
    display: flex;
    flex-direction: column;
    border-radius: 19px;
    background: $white;
    box-shadow: 0 20px 35px 0 rgba(0, 0, 0, 0.2);

    @media screen and (max-width: $mobile) {
        padding: 20px;
        border-radius: 32px;
    }

    .modal-head-icon {
        text-align: center;
        margin: 0 auto;

        @media screen and (max-width: $mobile) {
            display: none;
        }
    }

    .close-button {
        position: absolute;
        right: 20px;
        top: -5px;

        .close-icon {
            font-size: 45px;
            font-weight: $font-semi-bold;
        }
    }

    .modal-head {
        display: flex;
        flex-direction: column;
        text-align: center;

        .head-title {
            color: $black;
            text-align: center;
            font-size: 35px;
            font-weight: $font-bold;

            &.sub {
                font-weight: bold;
            }
        }
    }

    .modal-action-btns {
        margin-top: auto;
        display: flex;
        flex-direction: column;
        text-align: center;
        align-items: center;
        justify-content: center;

        a {
            margin-top: 25px;
            font-size: 20px;
            font-weight: bold;
            line-height: 1.3;
            color: $primary-blue;
            cursor: pointer;
        }
    }
}

.is-small {
    .modal-body {
        max-width: 550px;
        max-height: 100vh;
        min-height: 400px;
        height: auto;
        padding: 30px;
    }
}

.transparent {
    .modal-body {
        background-color: transparent;
        border-radius: 0;
    }
}

.animate {
    .modal-body {
        opacity: 1;
        transform: translateY(0);
    }

    .backdrop {
        opacity: 0.5;
    }
}
</style>
